import { Button, Modal, Text } from "@alpacahq/ui/old";

export interface OpraAgreementModalPresentationProps {
  isOpen: boolean;
  onClose: () => void;
  onDismiss: () => void;
  onViewAndSign: () => void;
}

export const OpraAgreementModalPresentation = ({
  isOpen,
  onClose,
  onDismiss,
  onViewAndSign,
}: OpraAgreementModalPresentationProps) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    title="Update to Market Data Subscription Plan"
    controls={
      <div className="flex w-full justify-between">
        <Button onClick={onDismiss} variant="alternate">
          Dismiss
        </Button>
        <Button onClick={onViewAndSign}>View and Sign</Button>
      </div>
    }
  >
    <Text>
      As part of the recent release, we have separated indicative feed and OPRA
      feed.
    </Text>
    <br />
    <Text>
      The great news is that your current subscription of Algo Trader Plus
      includes this OPRA feed. But before you can take advantage of it, you need
      to sign the agreement.
    </Text>
    <br />
    <Text>
      For more details about the difference of the feeds, please refer to our{" "}
      <a href="#">API docs</a>.
    </Text>
  </Modal>
);
